/**
 * Universal Layout component
 * Provides consistent Sidebar and TopNavigation across all pages
 * Navigation components are imported from Storybook to avoid code duplication
 */

import { ReactNode, useState, useEffect } from 'react'

import { supabase } from '../lib/supabase'
import { NavigationSidebar, NavigationTop } from '../stories/Navigation'

interface LayoutProps {
  children: ReactNode
}

function Layout({ children }: LayoutProps) {
  const [userInitials, setUserInitials] = useState<string>('U')

  useEffect(() => {
    const loadUserInitials = async () => {
      try {
        const { data: { user } } = await supabase.auth.getUser()
        if (!user) return

        // Try to get name from user_profile
        const { data: profile } = await supabase
          .from('user_profile')
          .select('first_name, last_name')
          .eq('user_id', user.id)
          .maybeSingle()

        if (profile?.first_name && profile?.last_name) {
          setUserInitials(`${profile.first_name[0]}${profile.last_name[0]}`.toUpperCase())
        } else if (user.email) {
          setUserInitials(user.email[0].toUpperCase())
        }
      } catch (err) {
        console.error('Error loading user initials:', err)
      }
    }

    loadUserInitials()
  }, [])

  return (
    <div className="flex h-screen bg-surface-default overflow-hidden">
      <NavigationSidebar userInitials={userInitials} />
      <div className="flex-1 flex flex-col overflow-hidden">
        <NavigationTop />
        <div className="flex-1 overflow-hidden" style={{ display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          {children}
        </div>
      </div>
    </div>
  )
}

export default Layout


